function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './NestedFilters.css';
import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Checkbox from './NestedFIltersComponents/Checkbox';
import DateRange from './NestedFIltersComponents/DateRange';
import DropDown from './NestedFIltersComponents/DropDown';
import ImageMultiSelect from './NestedFIltersComponents/ImageMultiSelect';
import NumberDropdown from './NestedFIltersComponents/NumberDropdown';
import RangeFilter from './NestedFIltersComponents/RangeFilter';
import SortDropdown from './NestedFIltersComponents/SortDropdown';
import Switch from './NestedFIltersComponents/Switch';
import TextFilter from './NestedFIltersComponents/TextFilter';
import { DropdownResults } from './NestedFIltersComponents/DropdownResults';
import { canUseDOM, get, replaceUrlPluses } from '../../../../utils';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { ANNUAL_FEE, totalParams } from '../../../Listing/index';
import { tealiumMergeClickData, tealiumClickFunc } from '../../../../utils/tealium';
import { qsToObject } from '../../../../utils/querystring';
import { ReactComponent as BackArrow } from '../../../../resources/icons/arrow-left-noborder.svg';
import { filtersStylesLtr, filtersStylesRtl } from '../../../DynamicListingComponent/DynamicListingComponent';
import { toggleLeftPanelOverflow } from '../utils/toggleLeftPanelOverflow';
//  TO DO: is modal view -> mobile version
//  intaractive page -> button with toggle panel aside

// to do change props
const NestedFilters = _ref => {
  let {
    fields,
    showLabel,
    resultsLabel,
    clearAllLabel,
    selectAllLabel,
    facets,
    params,
    nbHits,
    setListingFilter,
    facetsStats = {},
    resetFilterCallback,
    day,
    Cancel,
    FiltersCopy,
    lang,
    isTagPage,
    days,
    firstQuery,
    dictionary,
    imageDictionary,
    hits,
    defaultFacets,
    analytics,
    apllyFiltersOnChange = false,
    resetAllFiltersCallback,
    searchIndex = '',
    isNestedFilters = false,
    disabled = false,
    chosenTypes
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const filtersArray = get(fields, 'values');
  const filterWrapperRef = /*#__PURE__*/React.createRef();
  const [filterSubpanelText, setFilterSubpanelText] = React.useState('');
  const [clearAlllFilters, setclearAlllFilters] = React.useState(false);
  const [firstFilter, setFirstFilter] = React.useState(true);
  const [startPage, setStartPage] = React.useState(true);
  const [isSubmenuOpen, setSubmenuOpen] = React.useState(false);
  const [filtersCount, setFiltersCount] = React.useState(0);
  const [filtersValue, setFiltersValue] = React.useState({});
  const [totalFilters, settotalFilters] = React.useState(totalParams());
  const location = useLocation();
  let history = useHistory();
  const queryParams = qsToObject(location.search);
  React.useEffect(() => {
    filtersArray && filtersArray.map(el => {
      const preselectedTags = el.preselectedTags && el.preselectedTags.values.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      const fieldNameItem = get(el, 'fieldNameItem.item.fieldName.value');
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [el.name]: {
          value: el.preselectedTags && el.preselectedTags.values.length !== 0 ? preselectedTags.join(',') : null,
          facet: fieldNameItem
        }
      }));
    });
    return () => {
      setFiltersValue({});
    };
  }, [filtersArray]);
  React.useEffect(() => {
    let count = 0;
    for (let key in filtersValue) {
      const isFullFalseObj = () => {
        let isFullFalseObj = true;
        if (filtersValue[key].value !== null) {
          Object.values(filtersValue[key].value).forEach(el => {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filtersValue[key].value === 'string' ? filtersValue[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    }
    setFiltersCount(count);
  }, [filtersValue]);
  const filterSubPanelToggle = function (toggle) {
    let closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (filterWrapperRef.current) {
      if (toggle) {
        filterWrapperRef.current.classList.remove('filter__wrapper--submenu-open');
        setStartPage(true);
        setFirstFilter(true);
        setSubmenuOpen(false);

        // close common filter dropdown
        if (closePanel) {
          filterWrapperRef.current.classList.remove('filter__wrapper--open');
          setStartPage(true);
          setFirstFilter(true);
        }
      } else {
        filterWrapperRef.current.classList.add('filter__wrapper--submenu-open');
        setStartPage(false);
        setFirstFilter(false);
        setSubmenuOpen(true);
      }
      toggleLeftPanelOverflow(filterWrapperRef);
    }
  };
  const clearKeyPressHandler = e => {
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      clearAllCallback();
    }
  };
  const setFilter = function () {
    let firstFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setclearAlllFilters(false);
    setFirstFilter(firstFilter);
    setSubmenuOpen(false);
    setListingFilter();
  };
  const getFilterValue = (fieldName, facet, filterValue) => {
    if (filterValue === null || filterValue === '' || filterValue.length === 0 || Object.keys(filterValue).length === 0) {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: null,
          facet: facet
        }
      }));
    } else {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: filterValue,
          facet: facet
        }
      }));
    }
  };
  const clearAllCallback = () => {
    tealiumClickFunc(tealiumMergeClickData(analytics['filterOperationAnalytics'], params), 'Clear all');
    setclearAlllFilters(true);
    filterSubPanelToggle(true, false);
    setTimeout(() => {
      filtersArray && filtersArray.map(el => {
        const facetName = get(el, 'fieldNameItem.item.fieldName.value');
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: null,
            facet: facetName
          }
        }));
      });
    }, 10);
  };
  const controlBackBtn = isOpen => {
    setStartPage(isOpen);
  };
  const theme = get(sitecoreContext, 'themesOfPage');
  const themePrimary = get(theme, 'primary');
  const themePrimary__active = get(theme, 'primary_active');
  const submitAll = () => {
    const splitter = ';,;';
    const url = new URL(window.location.href);
    let newQueryArr = [];
    filtersArray.forEach(el => {
      filtersValue[el.name] = _objectSpread(_objectSpread({}, filtersValue[el.name]), {}, {
        fieldType: el.fieldTypeItem.item.fieldType.value
      });
    });
    for (let key in filtersValue) {
      if (typeof filtersValue[key].value === 'object' && filtersValue[key].value !== null && (filtersValue[key].fieldType === 'Dropdown' || filtersValue[key].fieldType === 'Dropdown Multi Select' || filtersValue[key].fieldType === 'Image Multi Select')) {
        if (filtersValue[key].value.length) {
          filtersValue[key].value.forEach(key => {
            newQueryArr.push(key);
          });
        } else {
          Object.keys(filtersValue[key].value).forEach(el => {
            if (filtersValue[key].value[el]) {
              const index = newQueryArr.indexOf(filtersValue[key].value[el]);
              if (index === -1) {
                newQueryArr.push(el);
              }
            }
          });
        }
        if (newQueryArr.length) {
          url.searchParams.set(filtersValue[key].facet, newQueryArr.join(splitter));
          history.push(`${url.search}${url.hash}`);
          setListingFilter();
          newQueryArr = [];
        }
      } else {
        if (filtersValue[key].value !== null) {
          url.searchParams.set(filtersValue[key].facet, `${filtersValue[key].value}`);
          history.push(`${url.search}${url.hash}`);
          setListingFilter();
        }
      }
    }
    filterSubPanelToggle(true);
    tealiumClickFunc(tealiumMergeClickData(analytics['filterAppliedAllAnalytics'], params), `${getFilterValueForAnalytics()}`);
  };
  const getFilterValueForAnalytics = () => {
    let analyticString = '';
    for (let key in filtersValue) {
      let value = '';
      let queries = queryParams[`${filtersValue[key].facet}`];
      if (queries) {
        queries = replaceUrlPluses(queries);
        value = ` ${key} :  ${queries ? queries.replaceAll(';', '') : queries}`;
      }
      analyticString = `${analyticString ? `${analyticString}, ${value}` : value}`;
    }
    return analyticString ? analyticString : ' ';
  };
  const columnsClass = 'col-md-12';
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    themePrimary: themePrimary,
    themePrimary__active: themePrimary__active,
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__wrapper",
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "mob-filter-toggle"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      if (canUseDOM) {
        window.scrollTo(0, 0);
      }
      filterWrapperRef.current.classList.add('filter__wrapper--open');
      toggleLeftPanelOverflow(filterWrapperRef);
      tealiumClickFunc(tealiumMergeClickData(analytics['filterOperationAnalytics'], params), 'Open');
    },
    disabled: disabled,
    className: " js-filters-trigger nested-filters-toggle"
  }, !disabled && filtersCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "filters-counter"
  }, " ", filtersCount), /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "nested-filters-icon",
    width: "21.876",
    height: "19.234",
    viewBox: "0 0 21.876 19.234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15486",
    "data-name": "Group 15486",
    transform: "translate(-387.562 -504.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(112.662 -106.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(275 611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M22.366,20.1a2.836,2.836,0,0,0-2.705,2.037h-2.9a.762.762,0,0,0-.764.8.788.788,0,0,0,.8.8h2.9A2.807,2.807,0,0,0,22.4,25.766a2.845,2.845,0,0,0,2.737-2.037H36.88a.8.8,0,0,0,0-1.591H25.135A2.914,2.914,0,0,0,22.366,20.1Zm.032,1.591a1.241,1.241,0,1,1-1.241,1.241A1.243,1.243,0,0,1,22.4,21.691Z",
    transform: "translate(-16 -20.1)",
    fill: "#aaaaac",
    stroke: "#aaaaac",
    "stroke-width": "0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(275 617.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M31.946,40.1a2.836,2.836,0,0,0-2.705,2.037H16.8a.769.769,0,0,0-.8.8.788.788,0,0,0,.8.8H29.241a2.807,2.807,0,0,0,2.705,2.037,2.845,2.845,0,0,0,2.737-2.037h2.2a.8.8,0,0,0,0-1.591h-2.2A2.845,2.845,0,0,0,31.946,40.1Zm.032,1.591a1.241,1.241,0,1,1-1.241,1.241A1.223,1.223,0,0,1,31.978,41.691Z",
    transform: "translate(-16 -40.1)",
    fill: "#aaaaac",
    stroke: "#aaaaac",
    "stroke-width": "0.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249",
    transform: "translate(275 624.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M26.185,62.1a2.836,2.836,0,0,0-2.705,2.037H16.8a.769.769,0,0,0-.8.8.788.788,0,0,0,.8.8h6.716a2.807,2.807,0,0,0,2.705,2.037,2.845,2.845,0,0,0,2.737-2.037H36.88a.8.8,0,0,0,0-1.591H28.923A2.845,2.845,0,0,0,26.185,62.1Zm.032,1.591a1.241,1.241,0,1,1-1.241,1.241A1.264,1.264,0,0,1,26.217,63.691Z",
    transform: "translate(-16 -62.1)",
    fill: "#aaaaac",
    stroke: "#aaaaac",
    "stroke-width": "0.2"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: e => {
      filterSubPanelToggle(true, false);
      tealiumClickFunc(tealiumMergeClickData(analytics['filterOperationAnalytics'], params), 'Cancel');
      e.stopPropagation();
    },
    className: "body-medium filter__header-back-link js-btn-close-panel"
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: `body-medium filter__header-links js-filters-close ${startPage ? 'cancel' : 'back'}`,
    onClick: () => {
      toggleLeftPanelOverflow(filterWrapperRef);
      tealiumClickFunc(tealiumMergeClickData(analytics['filterOperationAnalytics'], params), 'Close');
      if (startPage) {
        setStartPage(true);
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
        toggleLeftPanelOverflow(filterWrapperRef);
      } else {
        setStartPage(true);
        setFirstFilter(true);
      }
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium"
  }, /*#__PURE__*/React.createElement("span", null, FiltersCopy, " ", /*#__PURE__*/React.createElement("br", null), " ", chosenTypes.length ? chosenTypes[0].title : ''), /*#__PURE__*/React.createElement("span", {
    className: "js-opened-filter-label submenu__text"
  }, filterSubpanelText))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links cursor-pointer",
    onClick: () => {
      clearAllCallback();
      tealiumClickFunc(tealiumMergeClickData(analytics.filterOperationAnalytics, params), 'Clear all');
    }
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "filter__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filtersArray && filtersArray.map((filter, index) => {
    const filterName = get(filter, 'name');
    const fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
    const fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
    const fieldNamesItem = get(filter, 'fieldNameItems.items.0.fieldName.value');
    const item = !fieldNameItem ? get(filter, 'fieldNameItem.item', {}) : [];
    let fieldNameItemArray = !fieldNameItem ? Object.keys(item).map(name => get(item, `${name}.value`)) : [];
    let itemfacets;
    let defaultItemFacets;
    if (facets && defaultFacets) {
      itemfacets = facets[fieldNameItem] || facets[fieldNamesItem] || facets[fieldNameItem + 'RangeIndex'];
      defaultItemFacets = defaultFacets[fieldNameItem] || defaultFacets[fieldNamesItem] || defaultFacets[fieldNameItem + 'RangeIndex'];
    }
    if (fieldTypeItem === 'Dropdown') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facetsName: fieldNameItem,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        isNestedFilters: isNestedFilters,
        params: params
      });
    } else if (fieldTypeItem === 'Dropdown Multi Select') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        isNestedFilters: isNestedFilters,
        params: params
      });
    } else if (fieldTypeItem == 'Dropdown result') {
      return /*#__PURE__*/React.createElement(DropdownResults, {
        columnsClass: columnsClass,
        filteredOptions: hits ? hits : [],
        label: fieldNameItem
      });
    } else if (fieldTypeItem === 'Text') {
      return /*#__PURE__*/React.createElement(TextFilter, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        params: params,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        rtl: rtl,
        analytics: analytics,
        fullWidth: filtersArray.filter(f => get(f, 'fieldNameItems.items', []).some(i => get(i, 'fieldName.value', '').includes('venueMeetingRooms'))),
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        analytics: analytics,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range Multi Select') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        isMultiSelect: true,
        analytics: analytics,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Switch') {
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        setFilter: setFilter,
        facetsName: fieldNameItem,
        fields: filter,
        wrapperToggle: filterSubPanelToggle,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Toggle Multi Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: `${index}-${filterName}`,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        facetsName: fieldNameItem,
        selectAllLabel: selectAllLabel,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        isNestedFilters: isNestedFilters,
        params: params
      });
    } else if (fieldTypeItem === 'Toggle Single Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: `${index}-${filterName}`,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        isNestedFilters: isNestedFilters,
        params: params
      });
    } else if (fieldTypeItem === 'Date Range' || fieldTypeItem === 'Deals Date Range') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Date') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Sort') {
      return /*#__PURE__*/React.createElement(SortDropdown, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: get(filter, 'fieldNameItems.items'),
        facetsName: get(filter, 'fieldNameItems.items', []).map(f => get(f, 'fieldName.value', '')),
        dictionary: dictionary,
        defaultFacets: get(filter, 'fieldNameItems.items'),
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        searchIndex: searchIndex,
        isNestedFilters: isNestedFilters
      });
    } else if (fieldTypeItem === 'Number') {
      return /*#__PURE__*/React.createElement(NumberDropdown, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        dictionary: dictionary,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${index}-${filterName}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        isNestedFilters: isNestedFilters
      });
    } else if (fieldTypeItem === 'Image Multi Select') {
      return /*#__PURE__*/React.createElement(ImageMultiSelect, {
        filter: filter,
        hits: hits,
        params: params,
        facets: itemfacets,
        dictionary: dictionary,
        analytics: analytics,
        imageDictionary: imageDictionary,
        facetsName: fieldNamesItem,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        getFilterValue: getFilterValue
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      });
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "filter__btn-row"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: submitAll,
    className: "btn btn-primary js-filters-close"
  }, showLabel, " ", resultsLabel)))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    themePrimary,
    themePrimary__active
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles}  ${rtl ? filtersStylesRtl : filtersStylesLtr} ${rtl ? rtlStyles : ltrStyles}   `
  }, children);
};
export default NestedFilters;
const commonStyles = "c1cmm8yk";
const rtlStyles = "rqrbwqe";
const ltrStyles = "l1rxhm5v";